class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if(this.mainDetailsToggle != null){
      this.addEventListener('keyup', this.onKeyUp);
      //this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      //this.mainDetailsToggle.addEventListener('focusin', this.onFocusIn.bind(this));

      this.addEventListener('mouseenter', this.open.bind(this));
      this.addEventListener('mouseleave', this.close.bind(this));

      
    }
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    if (!this.contains(document.activeElement)) this.close();
    this.removePackery();
    /*setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })*/
  }
  onFocusIn() {		
    this.open();
    this.addPackery();
  }

  close() {
//     this.removePackery();
    this.mainDetailsToggle.removeAttribute('open');
  }

  open() {
    this.mainDetailsToggle.setAttribute('open','');
//     this.addPackery();
  }

  addPackery(){
    var selector = this.querySelector('.megamenu .header__submenu'),
        itemSelector = this.querySelector('[open].megamenu .header__submenu .header__submenu-list');
    var pckry = new Packery( '[open].megamenu .header__submenu' , {
      itemSelector: '[open].megamenu .header__submenu .header__submenu-list',
      gutter: 5,
      percentPosition: true,
    });
  }
  
  removePackery(){
    var selector = this.querySelector('.megamenu .header__submenu');
    var pckry = new Packery('[open].megamenu .header__submenu', {});
    pckry.destroy()
  }
}

customElements.define('details-disclosure', DetailsDisclosure);